import "./Divex.scss"
import { ImageSlider } from "./ImageSlider.tsx";
import { motion } from "framer-motion";
import { Typewriter } from 'react-simple-typewriter'
import { useState } from "react";

// Feature type
type Feature = {
  url: string;
  alt: string;
  description: string;
};

interface DivexProps {
  features: Feature[];
}

export default function Divex({ features }: DivexProps) {
  const [imageIndex, setImageIndex] = useState(0);

  return (
    <div className={"main-div content-rail"}>
      <div className={"main-div"}>
        <motion.div
          initial={{ opacity: 0, x: -500 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.75 }}
        >
          <div className={"img-container"}>
            <ImageSlider
              images={features}
              imageIndex={imageIndex}
              setImageIndex={setImageIndex}
            />
          </div>
        </motion.div>

        <motion.div
          key={imageIndex}
          initial={{ opacity: 0, x: 500 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.75 }}
        >
          <div className={"type-writer-features"} >
            <Typewriter
              words={[features[imageIndex].description]}
              typeSpeed={15}
              deleteSpeed={0}
              delaySpeed={0}
              loop={1}
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
}
